<template>
  <div>
    <QuestionList :data="articles"></QuestionList>
    <!-- 没有数据的处理 -->
    <div class="result-not-found" v-show="!articles.length">
      <!-- <p class="tips">
        未搜索到相关问题,请点击右上角客服进行咨询
      </p> -->
      <p class="tips">
        未搜索到相关问题,请重新搜索
      </p>
    </div>
  </div>
</template>
<script>
import QuestionList from '@/components/Question/List'
import { getQuestions } from '@/api'
export default {
  name: 'SearchList',
  components: {
    QuestionList
  },
  props: ['keyword'],
  data() {
    return {
      articles: []
    }
  },
  watch: {
    $route: 'fetch'
  },
  created() {
    this.fetch()
  },
  methods: {
    fetch() {
      getQuestions({
        sessionFrom: this.user.platform,
        searchWord: this.keyword
      }).then(res => {
        this.articles = res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.result-not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  .tips {
    font-size: 14px;
    color: #999999;
    line-height: 19px;
  }
}
</style>
